const customer2_email_reducer = (state = "", action) => {
	switch(action.type) {
		case 'UPDATECUST2EMAIL':
			return typeof action.payload !== "undefined" ? action.payload : "";

		default:
			return state;
	}
}
export default customer2_email_reducer;